import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LucideAngularModule, Tag, Percent, Gift, Clock, Pizza, Utensils, Sparkles, ArrowRight } from 'lucide-angular';
import { Subscription } from 'rxjs';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CartService } from '../../services/cart.service';
import { restaurants } from '../../data/mock';

@Component({
  selector: 'app-offers',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    LucideAngularModule,
    HeaderComponent,
    FooterComponent
  ],
      templateUrl: './offers.component.html',
  styleUrl: './offers.component.css'
})
export class OffersComponent implements OnInit, OnDestroy {
  featuredRestaurants = restaurants.slice(0, 8);
  cartCount = 0;
  private cartSubscription!: Subscription;

  mainOffers = [
    { title: 'Flat 30% OFF', subtitle: 'On All Orders', description: 'No minimum order value. Use code CAPITAL30', bgGradient: 'from-orange-500 to-red-500', icon: 'percent', code: 'CAPITAL30' },
    { title: '₹0 Delivery', subtitle: 'FREE Forever', description: 'No delivery fee on any order, anywhere', bgGradient: 'from-teal-500 to-emerald-500', icon: 'gift', code: null },
    { title: 'Happy Hours', subtitle: '4 PM - 6 PM', description: 'Extra 10% off during happy hours', bgGradient: 'from-purple-500 to-pink-500', icon: 'clock', code: 'HAPPY10' }
  ];

  categoryOffers = [
    { title: 'Tetos', price: '₹99', description: 'Pizzas starting at just ₹99', image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=400&q=80', icon: 'pizza' },
    { title: 'Deccan Spice', price: '₹149', description: 'Premium biryanis at unbeatable prices', image: 'https://images.unsplash.com/photo-1563379091339-03b21ab4a4f8?w=400&q=80', icon: 'utensils' },
    { title: 'Cooper', price: 'BOGO', description: 'Every Wednesday on select items', image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=400&q=80', icon: 'sparkles' }
  ];

  constructor(private cartService: CartService) {}

  ngOnInit() {
    this.cartSubscription = this.cartService.cart$.subscribe(() => {
      this.cartCount = this.cartService.getCartCount();
    });
  }

  ngOnDestroy() {
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
  }
}
